// extracted by mini-css-extract-plugin
export default {"mainCont":"ErrorElement_mainCont__OVcjo"};